/* ============================================================
   Luvero — JS propio (vanilla). Un init por componente, todos
   llamados desde un único DOMContentLoaded.
   ============================================================ */

(function () {
  'use strict';

  // Aplica (o reemplaza) el código de descuento activo del carrito y navega.
  // /discount/CODE?redirect= solo funciona de forma fiable si el carrito no
  // tiene ya otro código activo; /cart/update.js con {discount} sí lo reemplaza.
  function applyDiscountAndGo(code, redirectUrl) {
    var go = function () { window.location.href = redirectUrl; };
    if (!code) { go(); return; }
    fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ discount: code })
    }).then(go).catch(go);
  }

  // Segundos reales que quedan hasta la medianoche en la zona horaria dada
  // (usa Intl.DateTimeFormat, resistente al cambio de hora de verano/invierno).
  function secondsUntilMidnight(tz) {
    var fmt = new Intl.DateTimeFormat('en-GB', {
      timeZone: tz, hour12: false, hour: '2-digit', minute: '2-digit', second: '2-digit'
    });
    var h = 0, m = 0, s = 0;
    fmt.formatToParts(new Date()).forEach(function (p) {
      if (p.type === 'hour') h = parseInt(p.value, 10) % 24;
      if (p.type === 'minute') m = parseInt(p.value, 10);
      if (p.type === 'second') s = parseInt(p.value, 10);
    });
    var elapsed = (h * 3600) + (m * 60) + s;
    return 86400 - elapsed;
  }

  function initMidnightCountdown() {
    document.querySelectorAll('[data-lv-midnight-countdown]').forEach(function (el) {
      var tz = el.getAttribute('data-timezone') || 'Europe/Madrid';
      function tick() {
        var remaining = secondsUntilMidnight(tz);
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        function pad(n) { return (n < 10 ? '0' : '') + n; }
        el.textContent = pad(h) + ':' + pad(m) + ':' + pad(s);
      }
      tick();
      setInterval(tick, 1000);
    });
  }

  function initJudgemeEmptyHide() {
    var section = document.querySelector('.lv-producto-resenas');
    var widget = document.querySelector('.jdgm-review-widget');
    if (!section || !widget) return;
    function check() {
      var hasContent = widget.querySelector('.jdgm-rev, .jdgm-write-rev-link, .jdgm-form, form') !== null;
      section.style.display = hasContent ? '' : 'none';
    }
    check();
    var observer = new MutationObserver(check);
    observer.observe(widget, { childList: true, subtree: true });
    setTimeout(function () { observer.disconnect(); }, 6000);
  }

  function initReveal() {
    var els = document.querySelectorAll('.lv-reveal');
    if (!els.length) return;
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      els.forEach(function (el) { el.classList.add('lv-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('lv-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (el, i) {
      el.style.setProperty('--lv-delay', Math.min(i * 70, 420) + 'ms');
      observer.observe(el);
    });
  }

  function initCountUp() {
    var els = document.querySelectorAll('[data-lv-count-to]');
    if (!els.length) return;
    var reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (!entry.isIntersecting) return;
        observer.unobserve(entry.target);
        var el = entry.target;
        var to = parseInt(el.getAttribute('data-lv-count-to'), 10) || 0;
        if (reduced) { el.textContent = to; return; }
        var duration = 1100;
        var start = null;
        function step(ts) {
          if (start === null) start = ts;
          var progress = Math.min((ts - start) / duration, 1);
          var eased = 1 - Math.pow(1 - progress, 3);
          el.textContent = Math.round(eased * to);
          if (progress < 1) requestAnimationFrame(step);
        }
        requestAnimationFrame(step);
      });
    }, { threshold: 0.5 });
    els.forEach(function (el) { observer.observe(el); });
  }

  function initMarquee() {
    document.querySelectorAll('.lv-marquee-track').forEach(function (track) {
      if (track.dataset.lvCloned) return;
      var speed = parseFloat(track.getAttribute('data-speed')) || 32;
      track.innerHTML += track.innerHTML;
      track.dataset.lvCloned = 'true';
      track.style.animationDuration = speed + 's';
    });
  }

  function initGallery() {
    document.querySelectorAll('[data-lv-gallery]').forEach(function (gallery) {
      var main = gallery.querySelector('[data-lv-gallery-main]');
      var mainImg = main ? main.querySelector('img') : null;
      var thumbs = gallery.querySelectorAll('[data-lv-gallery-thumb]');
      if (!main || !mainImg || !thumbs.length) return;
      thumbs.forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          var full = thumb.getAttribute('data-full');
          var alt = thumb.getAttribute('data-alt') || '';
          if (!full) return;
          mainImg.style.opacity = '0';
          window.setTimeout(function () {
            mainImg.src = full;
            mainImg.alt = alt;
            mainImg.style.opacity = '1';
          }, 140);
          thumbs.forEach(function (t) { t.classList.remove('lv-thumb-active'); });
          thumb.classList.add('lv-thumb-active');
        });
      });
    });
  }

  function initComparador() {
    document.querySelectorAll('[data-lv-comparador]').forEach(function (wrap) {
      var handle = wrap.querySelector('[data-lv-comparador-handle]');
      var beforeWrap = wrap.querySelector('[data-lv-comparador-before]');
      if (!handle || !beforeWrap) return;
      var dragging = false;

      function setPos(pct) {
        pct = Math.min(100, Math.max(0, pct));
        wrap.style.setProperty('--lv-pos', pct + '%');
      }

      function posFromEvent(clientX) {
        var rect = wrap.getBoundingClientRect();
        return ((clientX - rect.left) / rect.width) * 100;
      }

      function onMove(e) {
        if (!dragging) return;
        var clientX = e.touches ? e.touches[0].clientX : e.clientX;
        setPos(posFromEvent(clientX));
      }
      function onUp() {
        dragging = false;
        wrap.classList.remove('lv-comparador-dragging');
      }

      handle.addEventListener('pointerdown', function () {
        dragging = true;
        wrap.classList.add('lv-comparador-dragging');
      });
      window.addEventListener('pointermove', onMove);
      window.addEventListener('pointerup', onUp);

      wrap.addEventListener('click', function (e) {
        if (e.target === handle || handle.contains(e.target)) return;
        setPos(posFromEvent(e.clientX));
      });

      handle.addEventListener('keydown', function (e) {
        var current = parseFloat(getComputedStyle(wrap).getPropertyValue('--lv-pos')) || 50;
        if (e.key === 'ArrowLeft') { setPos(current - 5); e.preventDefault(); }
        if (e.key === 'ArrowRight') { setPos(current + 5); e.preventDefault(); }
      });

      setPos(50);
    });
  }

  function initZonaTabs() {
    document.querySelectorAll('[data-lv-zona-tabs]').forEach(function (tabs) {
      var section = tabs.closest('.lv-section') || tabs.parentElement;
      var comparador = section.querySelector('[data-lv-comparador]');
      if (!comparador) return;
      var beforeImg = comparador.querySelector('[data-lv-comparador-before-img]');
      var afterImg = comparador.querySelector('[data-lv-comparador-after-img]');
      var beforeTag = comparador.querySelector('[data-lv-comparador-before-tag]');
      var afterTag = comparador.querySelector('[data-lv-comparador-after-tag]');
      var buttons = tabs.querySelectorAll('[data-lv-zona-tab]');

      buttons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          buttons.forEach(function (b) { b.classList.remove('lv-tab-active'); });
          btn.classList.add('lv-tab-active');
          var before = btn.getAttribute('data-before') || btn.getAttribute('data-before-fallback');
          var after = btn.getAttribute('data-after') || btn.getAttribute('data-after-fallback');
          var labelBefore = btn.getAttribute('data-label-before');
          var labelAfter = btn.getAttribute('data-label-after');
          if (beforeImg && before) { beforeImg.src = before; beforeImg.alt = labelBefore || ''; }
          if (afterImg && after) { afterImg.src = after; afterImg.alt = labelAfter || ''; }
          if (beforeTag && labelBefore) beforeTag.textContent = labelBefore;
          if (afterTag && labelAfter) afterTag.textContent = labelAfter;
          comparador.style.setProperty('--lv-pos', '50%');
        });
      });
    });
  }

  function initVariantPicker() {
    document.querySelectorAll('[data-lv-product-form]').forEach(function (form) {
      var dataEl = form.querySelector('[data-lv-variants-json]');
      var idInput = form.querySelector('input[name="id"]');
      var priceEl = form.querySelector('[data-lv-price]');
      var compareEl = form.querySelector('[data-lv-compare-price]');
      var submitBtn = form.querySelector('[data-lv-submit]');
      var submitLabel = form.querySelector('[data-lv-submit-label]');
      var packLinks = document.querySelectorAll('[data-lv-pack-link]');
      var packFaceEls = document.querySelectorAll('[data-lv-pack-face]');
      var stockEl = document.querySelector('[data-lv-stock]');
      var stockTextEl = stockEl ? stockEl.querySelector('[data-lv-stock-text]') : null;
      var galleryMainImg = document.querySelector('[data-lv-gallery-main] img');
      var galleryThumbs = document.querySelectorAll('[data-lv-gallery-thumb]');
      if (!dataEl || !idInput) return;
      var variants;
      try { variants = JSON.parse(dataEl.textContent); } catch (e) { return; }

      function money(cents) {
        return (cents / 100).toLocaleString('es-ES', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' €';
      }

      function findVariant() {
        var selects = form.querySelectorAll('[data-lv-option]');
        if (!selects.length) return variants[0];
        var values = Array.prototype.map.call(selects, function (s) { return s.value; });
        return variants.find(function (v) {
          return v.options.every(function (opt, i) { return opt === values[i]; });
        });
      }

      function update() {
        var variant = findVariant();
        if (!variant) return;
        idInput.value = variant.id;
        if (priceEl) priceEl.textContent = money(variant.price);
        if (compareEl) {
          if (variant.compare_at_price && variant.compare_at_price > variant.price) {
            compareEl.textContent = money(variant.compare_at_price);
            compareEl.hidden = false;
          } else {
            compareEl.hidden = true;
          }
        }
        if (submitBtn) {
          submitBtn.disabled = !variant.available;
          if (submitLabel) submitLabel.textContent = variant.available ? submitBtn.getAttribute('data-label-available') : submitBtn.getAttribute('data-label-sold-out');
        }
        packLinks.forEach(function (link) {
          var qty = link.getAttribute('data-qty');
          var code = link.getAttribute('data-code');
          var url = '/cart/' + variant.id + ':' + qty;
          if (code) url += '?discount=' + encodeURIComponent(code);
          link.setAttribute('href', url);
          link.setAttribute('data-variant-id', variant.id);
        });
        packFaceEls.forEach(function (el) { el.textContent = variant.title; });
        if (galleryMainImg && variant.image) {
          galleryMainImg.style.opacity = '0';
          window.setTimeout(function () {
            galleryMainImg.src = variant.image;
            galleryMainImg.alt = variant.title;
            galleryMainImg.style.opacity = '1';
          }, 140);
          galleryThumbs.forEach(function (t) {
            t.classList.toggle('lv-thumb-active', t.getAttribute('data-full') === variant.image);
          });
        }
        if (stockEl && stockTextEl) {
          var threshold = parseInt(stockEl.getAttribute('data-stock-threshold'), 10) || 0;
          var enabled = stockEl.getAttribute('data-stock-enabled') === 'true';
          var qtyLeft = variant.inventory_quantity;
          var showStock = enabled && variant.inventory_management && qtyLeft > 0 && qtyLeft <= threshold;
          if (showStock) {
            stockTextEl.textContent = stockEl.getAttribute('data-stock-before') + ' ' + qtyLeft + ' ' + stockEl.getAttribute('data-stock-after');
            stockEl.hidden = false;
          } else {
            stockEl.hidden = true;
          }
        }
      }

      form.querySelectorAll('[data-lv-option]').forEach(function (sel) {
        sel.addEventListener('change', update);
      });
      update();

      packLinks.forEach(function (link) {
        link.addEventListener('click', function (e) {
          e.preventDefault();
          if (link.classList.contains('lv-pack-loading')) return;
          var variantId = parseInt(link.getAttribute('data-variant-id'), 10);
          var qty = parseInt(link.getAttribute('data-qty'), 10);
          var code = link.getAttribute('data-code');
          link.classList.add('lv-pack-loading');
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: [{ id: variantId, quantity: qty }] })
          })
            .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
            .then(function () {
              applyDiscountAndGo(code, '/cart');
            })
            .catch(function () {
              link.classList.remove('lv-pack-loading');
              window.location.href = link.getAttribute('href');
            });
        });
      });
    });
  }

  function initBienvenidaDiscount() {
    var CODE = 'BIENVENIDA5';
    var WINDOW_MS = 15 * 60 * 1000;
    var KEY_FIRST = 'lv_first_visit';
    var KEY_REDIRECTED = 'lv_discount_redirected';
    var KEY_DISMISSED = 'lv_badge_dismissed';

    if (window.location.pathname.indexOf('/discount/') === 0) return;

    var first;
    try { first = localStorage.getItem(KEY_FIRST); } catch (e) { return; }
    var now = Date.now();

    if (!first) {
      try { localStorage.setItem(KEY_FIRST, String(now)); } catch (e) { return; }
      var already;
      try { already = sessionStorage.getItem(KEY_REDIRECTED); } catch (e) { already = '1'; }
      if (!already) {
        try { sessionStorage.setItem(KEY_REDIRECTED, '1'); } catch (e) {}
        var redirectTo = encodeURIComponent(window.location.pathname + window.location.search);
        window.location.replace('/discount/' + CODE + '?redirect=' + redirectTo);
        return;
      }
      first = String(now);
    }

    var firstMs = parseInt(first, 10);
    var remaining = WINDOW_MS - (now - firstMs);
    if (remaining <= 0) return;

    var dismissed;
    try { dismissed = sessionStorage.getItem(KEY_DISMISSED); } catch (e) { dismissed = null; }
    if (dismissed) return;

    var badge = document.createElement('div');
    badge.className = 'lv-bienvenida-badge';
    badge.innerHTML =
      '<span class="lv-bienvenida-icon">' + '\u{1F381}' + '</span>' +
      '<span class="lv-bienvenida-text">5% de bienvenida activo &middot; <span data-lv-bienvenida-timer></span></span>' +
      '<button type="button" class="lv-bienvenida-close" aria-label="Cerrar aviso">&times;</button>';
    document.body.appendChild(badge);

    var timerEl = badge.querySelector('[data-lv-bienvenida-timer]');
    var closeBtn = badge.querySelector('.lv-bienvenida-close');
    var intervalId = null;

    closeBtn.addEventListener('click', function () {
      badge.remove();
      try { sessionStorage.setItem(KEY_DISMISSED, '1'); } catch (e) {}
      if (intervalId) clearInterval(intervalId);
    });

    function tick() {
      var rem = WINDOW_MS - (Date.now() - firstMs);
      if (rem <= 0) {
        badge.remove();
        if (intervalId) clearInterval(intervalId);
        return;
      }
      var m = Math.floor(rem / 60000);
      var s = Math.floor((rem % 60000) / 1000);
      timerEl.textContent = m + ':' + (s < 10 ? '0' : '') + s;
    }
    tick();
    intervalId = setInterval(tick, 1000);
  }

  function initBundlePicker() {
    document.querySelectorAll('[data-lv-bundle]').forEach(function (bundle) {
      var tiers = bundle.querySelectorAll('[data-lv-tier]');
      var faceWrap = bundle.querySelector('[data-lv-face-slots]');
      var faceTemplate = bundle.querySelector('[data-lv-face-slot-template]');
      var submitBtn = bundle.querySelector('[data-lv-bundle-submit]');
      var errorEl = bundle.querySelector('[data-lv-bundle-error]');
      var faceOptions = [];
      try { faceOptions = JSON.parse(bundle.querySelector('[data-lv-faces-json]').textContent); } catch (e) { faceOptions = []; }

      var layout = bundle.closest('.lv-bundle-layout');
      var galleryMainImg = layout ? layout.querySelector('[data-lv-gallery-main] img') : null;
      var galleryThumbs = layout ? layout.querySelectorAll('[data-lv-gallery-thumb]') : [];

      function updateGallery(face) {
        if (!galleryMainImg || !face || !face.full) return;
        galleryMainImg.style.opacity = '0';
        window.setTimeout(function () {
          galleryMainImg.src = face.full;
          galleryMainImg.alt = face.name;
          galleryMainImg.style.opacity = '1';
        }, 140);
        galleryThumbs.forEach(function (t) {
          t.classList.toggle('lv-thumb-active', t.getAttribute('data-full') === face.full);
        });
      }

      function buildSlots(qty) {
        if (!faceWrap || !faceTemplate) return;
        faceWrap.innerHTML = '';
        for (let i = 0; i < qty; i++) {
          let node = faceTemplate.content.cloneNode(true);
          let slotEl = node.querySelector('[data-lv-face-slot]');
          let label = node.querySelector('[data-lv-face-slot-label]');
          let swatchWrap = node.querySelector('[data-lv-face-swatches]');
          if (label) label.textContent = (bundle.getAttribute('data-slot-label') || 'Mask') + ' ' + (i + 1);
          if (swatchWrap) {
            let defaultFace = faceOptions[i % faceOptions.length];
            swatchWrap.setAttribute('data-selected-id', defaultFace ? defaultFace.id : '');
            faceOptions.forEach(function (f, idx) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'lv-face-swatch' + (f.id === (defaultFace && defaultFace.id) ? ' lv-face-swatch-active' : '');
              btn.setAttribute('data-face-id', f.id);
              btn.setAttribute('aria-label', f.name);
              btn.innerHTML = '<img src="' + f.image + '" alt="' + f.name + '" loading="lazy"><span>' + f.name + '</span>';
              btn.addEventListener('click', function () {
                swatchWrap.querySelectorAll('.lv-face-swatch').forEach(function (b) { b.classList.remove('lv-face-swatch-active'); });
                btn.classList.add('lv-face-swatch-active');
                swatchWrap.setAttribute('data-selected-id', f.id);
                updateGallery(f);
              });
              swatchWrap.appendChild(btn);
            });
          }
          faceWrap.appendChild(node);
        }
        if (faceOptions.length) updateGallery(faceOptions[0 % faceOptions.length]);
      }

      var addonWrapEl = bundle.querySelector('[data-lv-bundle-addon]');
      var unlockEls = bundle.querySelectorAll('[data-lv-unlock]');
      var CHECK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.4" stroke-linecap="round" stroke-linejoin="round"><path d="M5 12.5l4.5 4.5L19 7"/></svg>';
      var LOCK_SVG = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round"><rect x="5" y="11" width="14" height="9" rx="1.5"/><path d="M8 11V7.5a4 4 0 0 1 8 0V11"/></svg>';

      function updateUnlocks(qty) {
        unlockEls.forEach(function (el) {
          var req = parseInt(el.getAttribute('data-unlock-qty'), 10) || 0;
          var unlocked = qty >= req;
          el.classList.toggle('lv-unlock-active', unlocked);
          var iconEl = el.querySelector('[data-lv-unlock-icon]');
          if (iconEl) iconEl.innerHTML = unlocked ? CHECK_SVG : LOCK_SVG;
        });
      }

      var promoEl = bundle.querySelector('[data-lv-promo-code]');

      function updatePromoCode(qty) {
        if (!promoEl) return;
        var req = parseInt(promoEl.getAttribute('data-promo-qty'), 10) || 0;
        var unlocked = req > 0 && qty >= req;
        promoEl.classList.toggle('lv-bundle-promo-unlocked', unlocked);
        var icon = promoEl.querySelector('[data-lv-promo-icon]');
        if (icon) icon.innerHTML = unlocked ? CHECK_SVG : LOCK_SVG;
        var label = promoEl.querySelector('[data-lv-promo-label]');
        if (label && unlocked && promoEl.dataset.unlockedText) label.textContent = promoEl.dataset.unlockedText;
        else if (label && !unlocked && promoEl.dataset.lockedText) label.textContent = promoEl.dataset.lockedText;
        var copyBtn = promoEl.querySelector('[data-lv-promo-copy-btn]');
        if (copyBtn) copyBtn.disabled = !unlocked;
      }

      function updateAddonDiscount(qty) {
        if (!addonWrapEl) return;
        var threshold = parseInt(addonWrapEl.getAttribute('data-addon-discount-qty'), 10) || 0;
        var badge = addonWrapEl.querySelector('[data-lv-addon-badge]');
        var priceNow = addonWrapEl.querySelector('[data-lv-addon-price-current]');
        var priceWas = addonWrapEl.querySelector('[data-lv-addon-price-was]');
        var note = addonWrapEl.querySelector('[data-lv-addon-swap-note]');
        var check = addonWrapEl.querySelector('[data-lv-addon-check]');
        var unlocked = threshold > 0 && qty >= threshold;
        addonWrapEl.classList.toggle('lv-bundle-addon-discounted', unlocked);
        if (badge) badge.hidden = !unlocked;
        if (note) note.hidden = !unlocked;
        if (priceNow && priceWas) {
          if (unlocked) {
            priceNow.textContent = '+ ' + addonWrapEl.getAttribute('data-addon-half-price');
            priceWas.textContent = addonWrapEl.getAttribute('data-addon-full-price');
            priceWas.hidden = false;
          } else {
            priceNow.textContent = '+ ' + addonWrapEl.getAttribute('data-addon-full-price');
            priceWas.hidden = true;
          }
        }
        if (unlocked && check && !addonWrapEl.dataset.lvAutoChecked) {
          check.checked = true;
          addonWrapEl.dataset.lvAutoChecked = '1';
        }
        if (!unlocked) delete addonWrapEl.dataset.lvAutoChecked;
      }

      tiers.forEach(function (tier) {
        tier.addEventListener('click', function () {
          tiers.forEach(function (t) { t.classList.remove('lv-tier-active'); });
          tier.classList.add('lv-tier-active');
          var qty = parseInt(tier.getAttribute('data-qty'), 10);
          bundle.setAttribute('data-active-qty', tier.getAttribute('data-qty'));
          bundle.setAttribute('data-active-code', tier.getAttribute('data-code') || '');
          buildSlots(qty);
          updateAddonDiscount(qty);
          updateUnlocks(qty);
          updatePromoCode(qty);
        });
      });

      if (promoEl) {
        var promoCopyBtn = promoEl.querySelector('[data-lv-promo-copy-btn]');
        if (promoCopyBtn) {
          promoCopyBtn.addEventListener('click', function () {
            if (promoCopyBtn.disabled) return;
            var code = promoEl.querySelector('.lv-bundle-promo-code');
            var text = code ? code.textContent : '';
            var done = function () {
              var original = promoCopyBtn.textContent;
              promoCopyBtn.textContent = 'Copied!';
              setTimeout(function () { promoCopyBtn.textContent = original; }, 1500);
            };
            if (navigator.clipboard && navigator.clipboard.writeText) {
              navigator.clipboard.writeText(text).then(done).catch(done);
            } else {
              done();
            }
          });
        }
      }

      var firstTier = bundle.querySelector('[data-lv-tier].lv-tier-active') || tiers[0];
      if (firstTier) {
        var firstQty = parseInt(firstTier.getAttribute('data-qty'), 10);
        bundle.setAttribute('data-active-qty', firstTier.getAttribute('data-qty'));
        bundle.setAttribute('data-active-code', firstTier.getAttribute('data-code') || '');
        buildSlots(firstQty);
        updateAddonDiscount(firstQty);
        updateUnlocks(firstQty);
        updatePromoCode(firstQty);
      }

      if (submitBtn) {
        submitBtn.addEventListener('click', function () {
          var slotWraps = faceWrap ? faceWrap.querySelectorAll('[data-lv-face-swatches]') : [];
          if (!slotWraps.length) return;
          var items = Array.prototype.map.call(slotWraps, function (w) {
            return { id: parseInt(w.getAttribute('data-selected-id'), 10), quantity: 1 };
          });
          var addonWrap = bundle.querySelector('[data-lv-bundle-addon]');
          var addonCheck = addonWrap ? addonWrap.querySelector('[data-lv-addon-check]') : null;
          var addonActive = !!(addonWrap && addonCheck && addonCheck.checked);
          if (addonActive) {
            items.push({ id: parseInt(addonWrap.getAttribute('data-addon-variant-id'), 10), quantity: 1 });
          }
          var code = bundle.getAttribute('data-active-code');
          if (addonActive && addonWrap) {
            var discountThreshold = parseInt(addonWrap.getAttribute('data-addon-discount-qty'), 10) || 0;
            var discountCode = addonWrap.getAttribute('data-addon-discount-code');
            var activeQty = parseInt(bundle.getAttribute('data-active-qty'), 10) || 0;
            if (discountThreshold > 0 && activeQty >= discountThreshold && discountCode) {
              code = discountCode;
            }
          }
          submitBtn.disabled = true;
          var originalLabel = submitBtn.textContent;
          submitBtn.textContent = bundle.getAttribute('data-loading-label') || 'Adding...';
          fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ items: items })
          })
            .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
            .then(function () {
              applyDiscountAndGo(code, '/cart');
            })
            .catch(function () {
              submitBtn.disabled = false;
              submitBtn.textContent = originalLabel;
              if (errorEl) { errorEl.hidden = false; }
            });
        });
      }
    });
  }

  function initSmartAddon() {
    document.querySelectorAll('[data-lv-smart-addon]').forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        if (link.classList.contains('lv-smart-loading')) return;
        var checkProductId = link.getAttribute('data-check-product-id');
        var threshold = parseInt(link.getAttribute('data-check-threshold'), 10) || 0;
        var fallbackUrl = link.getAttribute('data-addon-fallback-url') || link.href;
        var variantId = parseInt(link.getAttribute('data-addon-variant-id'), 10);
        var code = link.getAttribute('data-discount-code');

        fetch('/cart.js')
          .then(function (r) { return r.json(); })
          .then(function (cart) {
            var qty = (cart.items || []).reduce(function (sum, item) {
              return String(item.product_id) === String(checkProductId) ? sum + item.quantity : sum;
            }, 0);
            if (qty >= threshold && variantId && code) {
              link.classList.add('lv-smart-loading');
              return fetch('/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
              })
                .then(function (r) { if (!r.ok) throw new Error('cart-add-failed'); return r.json(); })
                .then(function () {
                  applyDiscountAndGo(code, '/cart');
                });
            }
            window.location.href = fallbackUrl;
          })
          .catch(function () {
            window.location.href = fallbackUrl;
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initReveal();
    initCountUp();
    initMarquee();
    initGallery();
    initComparador();
    initZonaTabs();
    initVariantPicker();
    initBundlePicker();
    initSmartAddon();
    initMidnightCountdown();
    initJudgemeEmptyHide();
  });
})();
